import api from "../../services/api";

export const setAuthorizatonHeader = (token, idEmpresa, nomeEmpresa, cnpj, razaoSicial) => {
    const PhpontoIdToken = `Bearer ${token}`;
    console.log('PhpontoIdToken', token);
    sessionStorage.setItem("PhpontoIdToken", PhpontoIdToken);
    api.defaults.headers.Authorization = PhpontoIdToken;
    setCompanyIdHeader(idEmpresa, nomeEmpresa, cnpj, razaoSicial)
};
  
export const setCompanyIdHeader = (_idEmpresa, _nomeEmpresa, _cnpj, _razaoSocial) => {
    const CompanyId = JSON.stringify({_idEmpresa, _nomeEmpresa, _cnpj, _razaoSocial})
    console.log('CompanyId', CompanyId);
    sessionStorage.setItem('CompanyId', CompanyId);
    api.defaults.headers.CompanyId = `CompanyId ${_idEmpresa}`;
};